export default "__VITE_ASSET__CErztwuj__"